module.exports = __webpack_public_path__ + "img/symbol-glasses-signature-eg.290c6d20.svg";